import { render, staticRenderFns } from "./UnTabUi.vue?vue&type=template&id=241b51aa&lang=pug&"
import script from "./UnTabUi.vue?vue&type=script&lang=js&"
export * from "./UnTabUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports